module.exports = __webpack_public_path__ + "img/totalPeople.aee17b4d.png";